@if (isOpen()) {
      <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in"
           (click)="closeModal()">
        
        <!-- Card do Modal -->
        <div class="bg-white rounded-2xl max-w-4xl w-full mx-4 shadow-2xl border border-gray-200 overflow-hidden animate-slide-up"
             (click)="$event.stopPropagation()">
          
          <!-- Header -->
          <div class="flex items-center justify-between p-6 border-b border-gray-100"
               [class]="getHeaderClass(currentAlert()?.type)">
            <div class="flex items-center gap-3">
              <div class="w-12 h-12 rounded-xl flex items-center justify-center bg-white/20">
                <lucide-icon [img]="getIcon(currentAlert()?.type)" size="28" class="text-white"></lucide-icon>
              </div>
              <div>
                <h2 class="text-lg font-bold text-white">Alerta de Patrulha</h2>
                <p class="text-sm text-white/80">{{ currentAlert()?.position?.name || 'Posto não identificado' }}</p>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <!-- Indicador de fila -->
              @if (queueCount() > 0) {
                <span class="px-2 py-1 text-xs font-medium bg-white/20 text-white rounded-full">
                  +{{ queueCount() }} na fila
                </span>
              }
              <button (click)="closeModal()" 
                      class="p-2 hover:bg-white/20 rounded-lg transition-colors text-white">
                <lucide-icon [img]="XIcon" size="20"></lucide-icon>
              </button>
            </div>
          </div>
          
          <!-- Barra de progresso -->
          <div class="px-6 pb-2">
            <div class="w-full h-1 bg-gray-200 rounded-full overflow-hidden">
              <div 
                class="h-full bg-gradient-to-r from-blue-500 to-blue-600 transition-all duration-1000 ease-linear"
                [style.width.%]="(getRemainingTime() / 15) * 100"
              ></div>
            </div>
            <div class="flex justify-between mt-1">
              <span class="text-xs text-gray-400">
                 Fecha em {{ getFormattedRemainingTime() }}
              </span>
              @if (queueCount() > 0) {
                <span class="text-xs text-blue-600 animate-pulse">
                   Próximo alerta em breve
                </span>
              }
            </div>
          </div>

          <!-- Body -->
          <div class="p-6 space-y-4">
            <!-- Título do Alerta -->
            <div>
              <h3 class="text-4xl font-bold text-gray-900">
                <span class="text-green-600">{{ currentAlert()?.position?.name || 'Posto não identificado' }}</span>: 
                {{ currentAlert()?.title }}
              </h3>
              <p class="text-sm text-gray-500 mt-1">{{ currentAlert()?.description }}</p>
            </div>

            <!-- Último patrulha -->
            @if (currentAlert()?.last_patrol_time) {
              <div class="p-3 bg-yellow-50 rounded-xl border border-yellow-200">
                <p class="text-xs text-yellow-700 font-medium">Último patrulha registrado</p>
                <p class="text-sm text-yellow-800">
                  {{ formatDateTime(currentAlert()?.last_patrol_time) }}
                </p>
              </div>
            }

            <!-- Ações -->
            <div class="flex gap-3 pt-4 border-t border-gray-100">
              <button (click)="resolveAlert()" 
                      class="flex-1 px-4 py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-xl transition-colors flex items-center justify-center gap-2 font-medium">
                <lucide-icon [img]="CheckCircleIcon" size="18"></lucide-icon>
                Resolver agora
              </button>
              <button (click)="closeModal()" 
                      class="px-4 py-2.5 border border-gray-200 hover:bg-gray-50 rounded-xl transition-colors text-gray-700 font-medium">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Estilos -->
    <style>
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes slideUp {
        from { transform: translateY(20px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
      }
      .animate-fade-in {
        animation: fadeIn 0.3s ease-out;
      }
      .animate-slide-up {
        animation: slideUp 0.3s ease-out;
      }
      .animate-pulse {
        animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
      }
    </style>